import { retry, timeoutWith } from 'rxjs/operators';

import { BehaviorSubject, Observable, throwError as observableThrowError } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';

// Adifium
import { ApiService } from 'libraries/service/api/api.service';
import { ErrorCatcherService } from 'libraries/service/errorCatcher/errorCatcher.service';

import { ISegmentRooming, ITraveller } from '../models/quote';
import { ISearchRequest, ITravellerObject } from 'libraries/service/resources/hotel/ISearchParameters';
import { IHotel } from '../models/quotation';
import { IDetailsDescription } from '../models/details';
import { ICompleteQuote, ICurrencies, IGetPropertyResponse, ISearchOffersResponse } from "libraries/service/resources/hotel/ISearchResponse";
import { ICurrency } from 'libraries/service/resources/model/search/ICurrency';
import { HotelResourceService } from 'libraries/service/resources/hotel/hotelResource.service';
import { Yii } from 'libraries/interfaces/Yii';
import { PropertyResourceService } from "libraries/service/resources/hotel/property-resource.service";
import { HttpClient } from "@angular/common/http";

// #TODO 30-04-2018_FG Terminer les interfaces

export interface ITravellerDistribution {
    [key: string]: {
        adult: number;
        child: number;
        infant: number;
    };
}

export interface ISelectedQuotation {
    selected: string;
    hotels: {
        [key: string]: ISelectedQuotationHotel;
    };
}

export interface ISelectedQuotationHotel {
    transactionId?: string;
    description: IDetailsDescription;
    offers: ICompleteQuote[];
    property: any;
    selectedOffer: string;
    mealplan: {syscode : string};
}

@Injectable()
export class HotelService extends ApiService {
    public currencies: ICurrencies= {};
    private request: ISearchRequest;
    private selectedHotel: IHotel;
    private travellersDitribution: ITravellerDistribution;
    private timeout: number = 80000;

    // #TODO 30-04-2018_FG Passer selectedQuotation + functions dans QuotationService
    private selectedQuotation: BehaviorSubject<ISelectedQuotation> = new BehaviorSubject({
        selected: null,
        hotels: {}
    });

    constructor (
        public http: HttpClient,
        private hotelResourceService: HotelResourceService,
        private propertyResourceService: PropertyResourceService,
    ) { super(http); }

    public reInit(): void{
        this.selectedQuotation = new BehaviorSubject({
            selected: null,
            hotels: {}
        });
        this.selectedHotel = undefined;
        this.currencies = {};
    }

    public clearRequest (): void {
        this.request = null;
    }

    public setRequestToCache (request: ISearchRequest): void {
        this.request = request;
    }

    public getRequestFromCache (): ISearchRequest {
        const requestClone: ISearchRequest = { ...this.request };
        return requestClone;
    }

    public setCurrencies (currencies: ICurrencies): void {
        const values : ICurrency[]  = Object.values(currencies);
        values.forEach((currency: ICurrency)=>{
            const dec = Number(currency.decimals);
            this.currencies[currency.code] = {
                code : currency.code,
                decimals : dec,
            };
        });
    }

    public getCurrencies (): ICurrencies {
        return this.currencies;
    }

    public getHotelId (property): string {
        return Object.keys(property)[0];
    }

    public getSelectedHotel (): IHotel {
        return this.selectedHotel;
    }

    public setSelectedHotel (selectedHotel: IHotel): void {
        this.selectedHotel = selectedHotel;
    }

    public getSelectedQuotation (): Observable<ISelectedQuotation> {
        return this.selectedQuotation.asObservable();
    }

    public getSelectedQuotationValue (): ISelectedQuotation {
        return this.selectedQuotation.value;
    }

    public getSelectedQuotationTransactionId (): string {
        const quotation: ISelectedQuotation = this.selectedQuotation.value;

        if (!quotation || !quotation.selected || !quotation.hotels) {
            return null;
        }

        return quotation.hotels[quotation.selected].transactionId;
    }

    public setSelectedQuotation (selectedQuotation: ISelectedQuotation): void {
        this.selectedQuotation.next(selectedQuotation);
    }

    public setTravellersDistribution (request): void {
        const matchingTravellers: { [key: string]: ITravellerObject[] } = setTravellersDispatching(request);
        let travellersByRooms;

        Object.keys(matchingTravellers).forEach((room) => {
            const rooms = matchingTravellers[room];

            travellersByRooms = {
                ...travellersByRooms,
                [room]: {
                    adult: rooms.filter((traveller) =>
                                traveller.type.toLowerCase() === 'adult').length,
                    child: rooms.filter((traveller) =>
                                traveller.type.toLowerCase() === 'child').length,
                    infant: rooms.filter((traveller) =>
                                traveller.type.toLowerCase() === 'infant').length
                }
            };
        });

        this.travellersDitribution = travellersByRooms;
    }

    public getTravellersDistribution (): ITravellerDistribution {
        return this.travellersDitribution;
    }

    public getHotelsListFromId (trips: string): Observable<ISearchOffersResponse> {
        return this.hotelResourceService.loadSearchAndApplyPermissions(trips);
    }

    public getHotelsList (request: ISearchRequest): Observable<ISearchOffersResponse> {
        return this.hotelResourceService.searchAndApplyPermissions(request).pipe(
            retry(3),
            timeoutWith(this.timeout, observableThrowError(new Error(Yii.t("wui-shared-js", "Le serveur ne répond pas")))),);
    }

    public getProperty (properties: string): Observable<IGetPropertyResponse> {
        return this.propertyResourceService.getProperty(properties);
    }
}

function getMatchingTravellers(rooms, travellers): { [key: string]: ITravellerObject[] } {
    let matchingTravellers = {};

    Object.keys(rooms).forEach((room) => {
        const travellersFound = [];

        rooms[room].map((traveller) => {
            if (travellers[traveller] && (traveller === travellers[traveller].xId || travellers[traveller].id)) {
                travellersFound.push(travellers[traveller]);
            }
        });

        matchingTravellers = { ...matchingTravellers, [room]: travellersFound };
    });

    return matchingTravellers;
}


function getRooms(rooming: ISegmentRooming): { [key: string]: ITraveller } {
    let rooms = {};

    for (const room in rooming) {
        if (room) {
            rooms = { ...rooms, [room]: rooming[room].traveller };
        }
    }

    return rooms;
}

function setTravellersDispatching(request): { [key: string]: ITravellerObject[] } {
    const rooming = request.segment[0].rooming;
    const travellers = request.traveller;

    const rooms = getRooms(rooming);

    return getMatchingTravellers(rooms, travellers);
}
